import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import DashboardPage from './pages/DashboardPage';
import Products from './pages/Products';
import SignInPage from './pages/Signin';
import AddProductPage from './pages/AddProduct';
import EditProductPage from './pages/EditProduct';
import Users from './pages/Users';
import AddUser from './pages/AddUser';
import ViewCustomer from './pages/ViewCustomer';
import ViewVendor from './pages/ViewVendor';
import EditCustomer from './pages/EditUser';
import ViewProduct from './pages/ViewProduct';
import Settings from './pages/Settings';
import Sales from './pages/SalesReport';
import { Toaster } from "react-hot-toast";
import HelpChat from './pages/Chat';
import Transactions from './pages/Transactions';
import NotificationsPage from "./pages/NotificationsPage";
import PendingProducts from "./pages/PendingProducts";
import CreateOrderPage from './pages/CreateOrderPage';
import ProtectedRoute from './routes/ProtectedRoute';

function AppContent() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isbarOpen, setIsbarOpen] = useState(false);

  const togglebar = () => setIsbarOpen(!isbarOpen);
  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

  const location = useLocation();
  const hideLayout = location.pathname === "/signin";

  const protectedPage = (element) => (
    <ProtectedRoute>{element}</ProtectedRoute>
  );

  return (
    <div className="flex font-jakarta relative transition-all duration-300">
      {!hideLayout && (
        <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      )}

      <div className="flex flex-col flex-1 min-h-screen bg-agarly-light/20 dark:bg-agarly-dark">
        {!hideLayout && (
          <Navbar
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            togglebar={togglebar}
            isbarOpen={isbarOpen}
            className="fixed top-0 left-0 w-full z-50"
          />
        )}

        <div
          className={
            hideLayout
              ? "w-full h-screen fixed left-0 top-0"
              : `flex-1 overflow-y-auto h-screen pt-20 fixed transition-all duration-300 left-0 w-full dark:bg-agarly-dark ${
                  isSidebarOpen
                    ? 'sm:left-72 sm:w-[calc(100%-18rem)]'
                    : 'sm:left-20 sm:w-[calc(100%-5rem)]'
                }`
          }
        >
          <Routes>
            <Route path="/" element={<Navigate to="/signin" replace />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/dashboard" element={protectedPage(<DashboardPage />)} />
            <Route path="/products" element={protectedPage(<Products />)} />
            <Route path="/products/add" element={protectedPage(<AddProductPage />)} />
            <Route path="/products/edit-product/:id" element={protectedPage(<EditProductPage />)} />
            <Route path="/products/view-product/:id" element={protectedPage(<ViewProduct />)} />
            <Route path="/Users" element={protectedPage(<Users />)} />
            <Route path="/Users/add" element={protectedPage(<AddUser />)} />
            <Route path="/Users/customers/view-Customer/:id" element={protectedPage(<ViewCustomer />)} />
            <Route path="/Users/vendors/view-Vendor/:id" element={protectedPage(<ViewVendor />)} />
            <Route path="/Users/edit-User/:id" element={protectedPage(<EditCustomer />)} />
            <Route path="/settings" element={protectedPage(<Settings />)} />
            <Route path="/sales" element={protectedPage(<Sales />)} />
            <Route path="/chat" element={protectedPage(<HelpChat />)} />
            <Route path="/transactions" element={protectedPage(<Transactions />)} />
            <Route path="/transactions/add" element={protectedPage(<CreateOrderPage />)} />
            <Route path="/notifications" element={protectedPage(<NotificationsPage />)} />
            <Route path="/products/pendingproducts" element={protectedPage(<PendingProducts />)} />
          </Routes>

          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                borderRadius: "12px",
                padding: "12px 20px",
                fontSize: "16px",
                textAlign: "center",
                background: "#0F172A",
                color: "#D7F5FF",
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
